<template>
  <Component
    :to="'/csearch/' + csearch.id"
    :is="tag"
    class="jps-curation-span"
    :nolink="!csearch"
  >
    <slot :csearch="csearch">{{ ls(csearch?.name) }}</slot>
  </Component>
</template>

<script lang="ts" setup>
interface Props {
  id: string
  tag?: string
}
const props = withDefaults(defineProps<Props>(), {
  tag: 'span',
})
const dataStore = useDataStore()
const csearch = dataStore.csearch(props.id)
const { ls } = useI18n()
</script>
